import React, { useEffect, useState, useRef } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import '../css/RewardDistribution.css';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const RewardDistribution = ({ onFundingTriggered }) => {
  const [chartData, setChartData] = useState({
    labels: ['Miners (90%)', 'Project Funding (10%)'],
    datasets: [
      {
        data: [100, 0],
        backgroundColor: ['#232323', '#3c024d'],
        borderColor: ['#444', '#770377'],
        borderWidth: 2,
        hoverOffset: 15,
        offset: [0, 0],
      },
    ],
  });

  const [isVisible, setIsVisible] = useState(false);
  const [showGlow, setShowGlow] = useState(false);
  const [isFinalState, setIsFinalState] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      const timeoutId = setTimeout(() => {
        setChartData({
          labels: ['Miners', 'Project Funding'],
          datasets: [
            {
              data: [90, 10],
              backgroundColor: ['#232323', '#3c024d'],
              borderColor: ['#444', '#770377'],
              borderWidth: 2,
              hoverOffset: 15,
              offset: [0, 0],
            },
          ],
        });

        setTimeout(() => {
          setShowGlow(true);

          setTimeout(() => {
            if (onFundingTriggered) {
              onFundingTriggered();
            }
            setTimeout(() => {
              setIsFinalState(true);
            }, 0);
          }, 0); 
        }, 1500); 
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [isVisible]);

  const getChartOptions = () => {
    const screenWidth = window.innerWidth;
    const labelFontSize = screenWidth < 768 ? 15 : 17;  

    return {
      responsive: true,
      animation: {
        duration: 1500,
        easing: 'easeOutQuad',
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (tooltipItem) {
              return `${tooltipItem.label}: ${tooltipItem.raw}%`;
            },
          },
        },
        datalabels: {
          color: '#ffffff',
          font: {
            weight: 'bold',
            size: labelFontSize, 
          },
          formatter: (value, context) => {
            const label = context.chart.data.labels[context.dataIndex];
            return `${label}: ${value}%`;
          },
          anchor: 'center',
          align: 'center',
        },
      },
      rotation: 108,
      circumference: 360,
    };
  };

  return (
    <div className="reward-distribution" ref={ref}>
      <h3>Reward Distribution</h3>
      <div className="reward-wrapper">
        <Pie data={chartData} options={getChartOptions()} className={isFinalState ? 'final' : ''} />
      </div>
    </div>
  );
};

export default RewardDistribution;
